import { db, auth, timestamp } from '@/firebaseConfig'
import { goToPath } from '@/mixins'

export default {
  state: {
    suppliers: [],
    indSupplier: null,
    units: ['Kg', 'Liter', 'Box', 'Item', 'Add your unit']
  },
  mutations: {
    addSupplier(state, supplier) {
      state.suppliers.push(supplier)
    },
    setIndSupplier(state, indSupplier) {
      state.indSupplier = indSupplier
    },
    resetIndSupplier(state) {
      state.indSupplier = null
    }
  },
  actions: {
    async registerIndSupplier({ commit }, supplier) {
      try {
        // create user with supplier credentials
        const newSupplier = await auth.createUserWithEmailAndPassword(supplier.email, supplier.password)

        const supplierDetails = {
          ...supplier,
          id: newSupplier.user.uid,
          isAdmin: false,
          isAccountConfirmed: false,
          isAccountApproved: false,
          hasFinishedAccountSetup: false,
          createdBy: 'self',
          createdAt: timestamp,
          updatedAt: timestamp,
          created_at_mills: '',
          creationError: ''
        }

        const publicFields = {
          created_at_mills: '',
          phoneNumber: supplier.phoneNumber,
          type: supplier.type
        }

        // add supplier's products counter
        await db.doc(`/independents/${supplierDetails.id}/products/counter`).set({ size: 0 })

        // add sort field to the supplier
        await db.doc(`/independents/${supplierDetails.id}`).set(publicFields)

        /** add an array to store ids of favoriteProductsIds */
        await db.doc(`/independents/${supplierDetails.id}/supplierData/favoriteProductsIds`).set({ ids: [] }, { merge: true })

        // add independent supplier in firestore
        db.doc(`/independents/${supplierDetails.id}/supplierData/details`).set(supplierDetails)
          .then(() => {
            /** redirect use to the admin page */
            goToPath('/my-products')
          })
          .catch(err => commit('setError', err))
      } catch (err) {
        commit('setError', err)
      }
    },

    async registerBusSupplier({ commit }, supplier) {
      try {
      // create user with supplier credentials
        const newSupplier = await auth.createUserWithEmailAndPassword(supplier.email, supplier.password)

        const supplierDetails = {
          ...supplier,
          id: newSupplier.user.uid,
          isAdmin: false,
          isAccountConfirmed: false,
          isAccountApproved: false,
          hasFinishedAccountSetup: false,
          createdBy: 'self',
          createdAt: timestamp,
          updatedAt: timestamp,
          created_at_mills: '',
          creationError: ''
        }

        const publicFields = {
          created_at_mills: '',
          phoneNumber: supplier.phoneNumber,
          type: supplier.type,
          companyName: supplier.companyName
        }

        // add supplier's products counter
        await db.doc(`/businesses/${supplierDetails.id}/products/counter`).set({ size: 0 })

        // add sort field to the supplier
        await db.doc(`/businesses/${supplierDetails.id}`).set(publicFields)

        /** add an array to store ids of favoriteProductsIds */
        await db.doc(`/businesses/${supplierDetails.id}/supplierData/favoriteProductsIds`).set({ ids: [] }, { merge: true })

        /** add an array to store ids of products to which the supplier has sent a message to the supplier */
        await db.doc(`/businesses/${supplierDetails.id}/messages/contactedProductsIds`).set({ ids: [] }, { merge: true })

        // add independent supplier in firestore
        await db.doc(`/businesses/${supplierDetails.id}/supplierData/details`).set(supplierDetails)
          .then(() => {
            /** redirectmy- use to the admin page */
            goToPath('/my-products')
          })
          .catch(err => commit('setError', err))
      } catch (err) {
        commit('setError', err)
      }
    },

    async fetchSupplierInfo({ commit }, supplier) {
      // TODO: check if the supplier is already in the store
      // then don't query firestore
      const supplierPath = supplier.type === 'business' ? `businesses/${supplier.id}` : `independents/${supplier.id}`
      const supplierData = await db.doc(supplierPath).get()
      const supplierInfo = { ...supplierData.data(), id: supplier.id }

      commit('addSupplier', supplierInfo)
      return new Promise((resolve, reject) => {
        resolve(supplierInfo)
      })
    },

    // async fetchSupplier({ commit, dispatch }, user) {
    //   commit('setLoading', true)
    //   const supplierPath = user.displayName === 'business' ? `businesses/${user.uid}/supplierData/details` : `independents/${user.uid}/supplierData/details`
    //   try {
    //     const supplierData = await db.doc(supplierPath).get()
    //     commit('setUser', supplierData.data())
    //     dispatch('getFavoriteProductsIds')
    //     goToPath('/')
    //   } catch (err) {
    //     commit('setError', err)
    //   }
    //   commit('setLoading', false)
    // },

    fetchIndSupplier({ commit, dispatch }, indSupplier) {
      db.doc(`/independents/${indSupplier.uid}/supplierData/details`)
        .get()
        .then((doc) => {
          const userData = doc.data()
          const user = {
            id: userData.id,
            firstName: userData.firstName,
            lastName: userData.lastName,
            phoneNumber: userData.phoneNumber,
            email: userData.email,
            isAccountVerified: userData.isAccountVerified,
            isAdmin: false,
            type: userData.type
          }

          dispatch('loadSupplierProducts', user)
            .then(() => {
              // set error if ever there's a problem and instruct the user to reload the page(use a button to trigger the loadSupplierProducts action again)
              commit('setUser', user)
              goToPath('/my-products')
              dispatch('getFavoriteProductsIds')
            })
            .catch(err => commit('setError', err))
        })
        .catch(err => commit('setError', err))
    },

    fetchBusSupplier({ commit, dispatch }, busSupplier) {
      db.doc(`/businesses/${busSupplier.uid}/supplierData/details`)
        .get()
        .then((doc) => {
          const userData = doc.data()
          const user = {
            id: userData.id,
            firstName: userData.firstName,
            lastName: userData.lastName,
            phoneNumber: userData.phoneNumber,
            email: userData.email,
            isAccountVerified: userData.isAccountVerified,
            isAdmin: false,
            type: userData.type
          }

          dispatch('loadSupplierProducts', user)
            .then(() => {
              // set error if ever there's a problem and instruct the user to reload the page(use a button to trigger the loadSupplierProducts action again)
              commit('setUser', user)
              goToPath('/my-products')
              dispatch('getFavoriteProductsIds')
            })
            .catch(err => {
              commit('setError', err)
            })
        })
        .catch(err => commit('setError', err))
    }
    // TODO: load 10 first products, then load the rest on next page
    // loadSupplierProducts({ commit }, user) {
    //   return new Promise((resolve, reject) => {
    //     const productsPath = user.type === 'business' ? `businesses/${user.id}/products` : `independents/${user.id}/products`
    //     db.collection(productsPath).get()
    //       .then((snap) => {
    //         const data = []
    //         snap.forEach(doc => {
    //           data.push(doc.data())
    //         })

    //         const products = data.filter(product => product.created_at_mills)
    //         commit('setSupplierProducts', products)
    //         resolve()
    //       })
    //       .catch((err) => {
    //         reject(err)
    //       })
    //     // }
    //   })
    // }
  },

  getters: {
    supplierById: state => id => {
      return state.suppliers.find(supplier => supplier.id === id)
    },
    units(state) {
      return state.units
    }
  }
}
